/** Display timestamp in picture viewers — always the owning answer's createdAt. */
export function getPictureDisplayTimestamp(
  picture: { answer?: { createdAt?: string | number | Date } } | null | undefined,
  answerCreatedAt?: string | number | Date | null,
): string | number | Date | null | undefined {
  return picture?.answer?.createdAt ?? answerCreatedAt ?? null;
}
